import NavigableValidation, {ErrorNavOpts} from "./navigableValidation";
import ContentElementPropertiesValidator from "../navigableValidators/contentElementPropertiesValidator";
import ListViewContentElement from "../listViews/elements/listViewContentElement";
import {ListViewContentElementControlType} from "~/enums/listViews/listViewContentElementControlType";
import {IErrorNavOpts} from "~/models/validationError";
import NavigableValidator from "~/models/navigableValidators/navigableValidator";
import PresenceValidator from "~/models/validators/presenceValidator";
import {ValidationErrorMessage} from "~/enums/validationErrorMessage";
import {ErrorType} from "~/enums/ErrorType";
import {ValidationModalSection} from "~/models/navigableValidations/validationSections";
import { ViewLinkType } from "../listViews/viewLinkType";
import { ListViewContentElementCapability } from "../listViews/elements/listViewContentElementCapability";

export default class ListViewContentElementValidation extends NavigableValidation<ListViewContentElement> {
  validators = [
    new ContentElementPropertiesValidator({
      validatorKey: 'content_elements',
      section: ValidationModalSection.Layout
    }),
    new NavigableValidator({
      validatorKey: 'property_id',
      section: ValidationModalSection.Layout,
      conditional: (model: ListViewContentElement, validatorKey) => {
        return model.content_type === ListViewContentElementControlType.ModelProperty
      },
      validator: (value, model: ListViewContentElement) => {
        return PresenceValidator.isValid(value) || PresenceValidator.isValid(model['builtin_property_type']) || PresenceValidator.isValid(model['reference_path']);
      },
      message: ValidationErrorMessage.MustBePresent,
      type: ErrorType.mustBePresent
    }),
    new NavigableValidator({
      validatorKey: 'linked_view_id',
      section: ValidationModalSection.Layout,
      conditional: (model: ListViewContentElement, validatorKey) => {
        return model.can(ListViewContentElementCapability.viewLinkable) && model.linked_view_type !== ViewLinkType.none
      },
      validator: (value, model: ListViewContentElement) => {
        return PresenceValidator.isValid(value);
      },
      message: ValidationErrorMessage.MustBePresent,
      type: ErrorType.mustBePresent
    }),
    new NavigableValidator({
      validatorKey: 'linked_view_id',
      section: ValidationModalSection.Layout,
      conditional: (model: ListViewContentElement, validatorKey) => {
        return model.can(ListViewContentElementCapability.viewLinkable) && model.linked_view_type !== ViewLinkType.none && PresenceValidator.isValid(model.linked_view_id)
      },
      validator: (value, model: ListViewContentElement) => {
        return PresenceValidator.isValid(model.linked_view_title)
      },
      message: "Drill down view must be present",
      type: ErrorType.mustBePresent
    })
  ];

  errorNavOpts(validator, propName: string, value?): IErrorNavOpts{
    return new ErrorNavOpts({
      path: validator.section.toLowerCase(),
      query: {selectedId: this.model.client_id},
      targetElementId: this.model.idForProp(propName),
    });
  }
}
